import { Button, Group, Modal, Text } from '@mantine/core'
import { useForm } from '@mantine/form'
import { Tradeshow } from 'api/dto/tradeshow'
import { useSendEmailsExhibitor } from 'api/query/exhibitor'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { showNotification } from '@mantine/notifications'
import { getApiErrorMessage } from 'utils/tradeshow'

interface SendEmailsExhibitorProps {
  opened: boolean
  onClose: () => void
}

export function SendEmailsExhibitor({ opened, onClose }: SendEmailsExhibitorProps) {
  const { t } = useTranslation()
  const { tradeshowId } = useParams()
  const form = useForm<Tradeshow>({})
  const { mutateAsync: sendEmails } = useSendEmailsExhibitor(tradeshowId!)
  const [submitting, setSubmitting] = useState(false)

  async function onSubmit() {
    setSubmitting(true)
    try {
      await sendEmails()
    } catch (error) {
      showNotification({ title: t('common.error.title'), message: getApiErrorMessage(error), color: 'red' })
    }
    setSubmitting(false)
    onClose()
  }

  return (
    <Modal size="lg" opened={opened} onClose={onClose} title={t('exhibitor.send-email')}>
      <form onSubmit={form.onSubmit(onSubmit)}>
        <Text size="15px">{t('exhibitor.email-are-you-sure')}</Text>

        <Group mt={30} position="right">
          <Button disabled={submitting} variant="outline" size="xs" color="red" onClick={onClose}>
            {t('common.cancel')}
          </Button>

          <Button loading={submitting} disabled={submitting} size="xs" variant="outline" color="green" type="submit">
            {t('common.send')}
          </Button>
        </Group>
      </form>
    </Modal>
  )
}
